/**
 * Styles that take an element off-screen but keep it in the accessibility
 * tree, for text only screen readers need. MUI's `visuallyHidden` lives in
 * `@mui/utils`, which we only have transitively, so it's defined here.
 */
export const visuallyHidden = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  whiteSpace: 'nowrap',
  border: 0,
} as const
